<div>
  <span placement="right" pTooltip="{{content}}" tooltipPosition="right">{{content}}</span>
</div>
